import { $, $$, insertHTML } from 'src/shared/js/utils/dom';
import WaterfallColumns from 'src/shared/js/modules/waterfall';
import CustomLightbox from 'src/shared/js/modules/lightbox';

class Grid {
  BREAKPOINT = 767;

  constructor(props) {
    this.container = props.container;
    this.waterfall = false;
    this.lightbox = false;
  }

  init = () => {
    this.appendRatioPlaceholder();
    this.initWaterFall();
  };

  appendRatioPlaceholder = () => {
    const items = $$('.image-gallery__item', this.container);
    const template = `<span class="image-gallery-placeholder"></span>`;

    items.forEach(item => {
      const figure = $('figure', item);
      insertHTML(figure, 'afterbegin', template);
    });
  };

  updateGrid() {
    this.waterfall.updateWaterfall();
  }

  initWaterFall = () => {
    const toggles = $$('[class$="__lightbox-toggle', this.container);
    const lightbox = new CustomLightbox(toggles, this.container);
    lightbox.init();

    const sizes = [
      { columns: 1, gutter: 15 },
      { mq: '768px', columns: 3, gutter: 0 },
    ];

    this.waterfall = new WaterfallColumns({
      container: $('.image-gallery__wrapper', this.container),
      items: $$('.image-gallery__item', this.container),
      mediaQueries: sizes,
    });

    this.waterfall.init();
  };
}

const galleryGrid = $$('.image-gallery__grid');

galleryGrid.length &&
  galleryGrid.forEach(gallery => {
    const grid = new Grid({
      container: gallery,
    });

    grid.init();
  });
